<!-- 展示元素：共XX家、门店头图（尺寸ui定）、门店名称、门店距离（大于60km展示大于60km）、拨打电话icon（点击调起手机电话），商户地址，进入门店列表页按钮
    门店只有1家 不展示适用门店数量，无进入门店列表页按钮
    门店有多家展示“查看全部xx家门店”点击跳到门店列表
    门店列表展示逻辑：按照距离由近及远进行展示，如果距离＞60km，展示＞60km。
    交互说明：①点击门店头图，名称，距您2.2km区域跳转到门店主页
    ②点击地址区域,显示门店地址信息，
    ③点击电话调起手机电话
    ④点击查看全部门店，跳转到全部门店列表页-->
<template>
  <section class="store-info--w" v-if="storeLength > 0">
    <div class="si--header">
      <!--skuTag in [1,2,3,5] 显示为适用商家-->
      <div class="si--title pf-medium">{{ storeLabel }}</div>
      <div class="si--view-list" v-if="storeLength > 1" @click="showStoreList">
        <span v-if="isOpenReplacement">更换{{ storeLabel }}</span>
        <span v-else> 查看全部{{ storeLength }}家门店&nbsp;</span
        ><i class="icon-arrow--r"></i>
      </div>
    </div>
    <div class="si--middle">
      <a
        class="si--middle--left"
        :href="'//life.cekid.com/h5/shop?businessId=' + storeInfo.businessKey"
        @click="storeClick"
      >
        <img class="si--avatar" :src="storeInfo.storeHeadImg" />
        <div class="si--content">
          <div class="si--name elps">{{ storeInfo.storeName }}</div>
          <div class="si--distance" v-if="isAuthorizedPosition">
            <span>距您&nbsp;{{ distance }}</span>
          </div>
        </div>
      </a>

      <a :href="'tel:' + storeInfo.mobile" @click="telClick">
        <i class="icon-call"></i
      ></a>
    </div>
    <div class="si--btm" @click="goMap">
      <i class="icon-position"></i>
      <p>
        {{ address }}
      </p>
      <i class="icon-showMore"></i>
    </div>
    <mockRouterAction
      v-if="storeLength > 1"
      :router-name="routerName"
      title-from="服务详情"
      title-to="门店列表"
      ref="mra"
    >
      <storeList
        :params="{ storeList }"
        :isOpenReplacement="isOpenReplacement"
        :selectedStoreId="storeInfo.storeId"
        @onChange="handleStoreChange"
      ></storeList>
    </mockRouterAction>
  </section>
</template>
<script>
import M from './mixin.js'
export default {
  mixins: [M],
  inject: {
    busiTelTrackParams: {
      default: null
    },
    storeInfoTrackParams: {
      default: null
    }
  },
  methods: {
    storeClick() {
      this.storeInfoTrackParams &&
        this.$$newTrackClick(this.storeInfoTrackParams)
    },
    telClick() {
      this.busiTelTrackParams && this.$$newTrackClick(this.busiTelTrackParams)
    }
  }
}
</script>
<style lang="scss" scoped src="../style.scss"></style>
